import React from "react";

export const CountriesColumnFormatter = (values) => {
    //console.log('values----------->:', values)
    let str = ''
    if (values.length > 0) {
  
      values.map((valC, ind) => {
        if (ind == 0) {
          str = valC.name
        } else {
          str = str + " , " + valC.name
        }
      })
    } else {
      str = "-"
    }
    return str;
    // return `${IMAGE_URL}/${value}`;
  }